import React, { useState } from 'react';
import { weddingInvitationsPageData } from '@data-ts/pages/wedding-invitations';
import {
  SectionContainer,
  TextPairingContainer,
  StyledBackgroundImage,
  StyledTopWave,
  InvitesGalleryColumn,
  InvitesGalleryBox,
  InvitesGalleryImage,
  StyledPhotoCredit,
} from './SmartRSVPSection.styles';
import { Columns } from '@components/Columns';
import { CTALink } from '@components/CTALink';
import { Box } from '@components/Box';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';

export const SmartRSVPSection: React.FC = () => {
  const { invitationSmartRSVPSection } = weddingInvitationsPageData;
  const sectionId = 'WeddingInvitationSmartRSVPSection';
  const [isScrolledIntoView, setScrolledIntoView] = useState(false);
  return (
    <SectionContainer id={sectionId}>
      <LazyLoadWrapper beforeLoad={() => setScrolledIntoView(true)}>
        <div />
      </LazyLoadWrapper>
      <StyledTopWave src="invites-gallery/top-wave-v2.svg" />
      <StyledBackgroundImage
        paddingTop={[10, 12]}
        backgroundImage="invites-gallery/weddingparty_bg-v2.jpg"
        isScrolledIntoView={isScrolledIntoView}
      >
        <Columns centered verticalAlign="center">
          <Columns.Column width={5} offset={1}>
            <TextPairingContainer
              eyebrow={invitationSmartRSVPSection.eyebrow}
              eyebrowColor="humana3"
              eyebrowVariant={'sectionEyeBrow20'}
              eyebrowTagName="h2"
              title={invitationSmartRSVPSection.title}
              titleVariant={'hed56'}
              titleColor="neutra1"
              titleTagName="h2"
              body={invitationSmartRSVPSection.body}
              bodyColor="neutra1"
              bodyVariant="featureCopy17"
            />
            <Box marginTop={['24px']}>
              <CTALink id="exploreGuestList" hasChevron={true} variant="alternative" typography="featureHed17" href="/online-rsvp">
                {invitationSmartRSVPSection.exploreRSVP}
              </CTALink>
            </Box>
          </Columns.Column>
          <InvitesGalleryColumn width={5} offset={1}>
            <InvitesGalleryImage src="invites-gallery/rsvp-v2.png" />
          </InvitesGalleryColumn>
        </Columns>
        <InvitesGalleryBox>
          <InvitesGalleryImage src="invites-gallery/rsvp-v2.png" />
        </InvitesGalleryBox>
      </StyledBackgroundImage>
      <StyledPhotoCredit color="mono7" id="photoCreditWeddingInvitationsRSVP" />
    </SectionContainer>
  );
};
